import Index from '@/components/Index';
import NotFound from '@/components/NotFound';
import Login from '@/components/login/Login';

 const router = [
		{
			path: '/',
			name: '',
			component: Index,
            children:[
                {
                    path: 'jyj',
                    name: '教育局管理',
                    component: function(resolve){
                        require(['@/components/jyj/Jyj'], resolve)
                    }
                },
                {
                    path: 'class',
                    name: '班级管理',
                    component: function(resolve){
                        require(['@/components/class/Class'], resolve)
                    }
                },
                {
                    path: 'school/:tabnum',
                    name: '校务管理',
                    component: function(resolve){
                        require(['@/components/school/SchoolTabs'], resolve)
                    }
                },
                {
                    path: 'school/:classid/:tabnum',
                    name: '校务班级管理',
                    component: function(resolve){
                        require(['@/components/school/SchoolClassTabs'], resolve)
                    }
                },
                {
                    path:'',
                    name:'页面未找到2',
                    component:NotFound
                }
            ]
		},
        {
            path:'/login',
            name:'登录',
            component:Login
        },
		{
			path:'*',
			name:'页面未找到',
			component:NotFound
		}
	];





export default router;



// WEBPACK FOOTER //
// ./src/router/index.js